import Handlebars from 'handlebars/runtime'

export default HandlebarsHelper => {
  Handlebars.registerHelper('checked', function (value, currentValue) {
    if (value === undefined) return ''
    return value === currentValue ? 'checked' : ''
  })
  Handlebars.registerHelper('selected', function (option, value) {
    if (option === value) {
      return ' selected'
    } else {
      return ''
    }
  })
  Handlebars.registerHelper('times', function (n, block) {
    var accum = ''
    for (var i = 1; i < n + 1; ++i) {
      accum += block.fn(i)
    }
    return accum
  })
  Handlebars.registerHelper('nl2br', function (text) {
    text = Handlebars.Utils.escapeExpression(text)
    text = text.replace(/(\r\n|\n|\r)/gm, '<br>')
    return new Handlebars.SafeString(text)
  })
}



// WEBPACK FOOTER //
// ./src/assets/js/handlebarsHelper.js